import type { BoardObject } from '../../../shared/types.ts';
import type { ImageCache } from '../images.ts';
import { drawShape } from './shape.ts';
import { drawSticky } from './sticky.ts';
import { drawFrame, drawFreehand, drawImageObject } from './content.ts';
import { drawCard } from './card.ts';
import { drawAudio } from './audio.ts';

export interface DrawContext {
  lod: boolean;     // below the level-of-detail zoom (spec §5.1)
  zoom: number;
  scale: number;    // device px per world unit
  images: ImageCache;
  /** Live editing (not export, not view-only): draws affordances like "+ Add card". */
  editable: boolean;
}

/**
 * Draws `o` in its local frame (origin at unrotated top-left); the caller sets
 * the transform. Connectors are drawn separately, in world coordinates.
 */
export function drawObject(ctx: CanvasRenderingContext2D, o: BoardObject, dc: DrawContext): void {
  switch (o.type) {
    case 'sticky': return drawSticky(ctx, o, dc.lod);
    case 'shape': return drawShape(ctx, o, dc.lod);
    case 'freehand': return drawFreehand(ctx, o, dc.lod);
    case 'image': return drawImageObject(ctx, o, dc.images, dc.scale);
    case 'audio': return drawAudio(ctx, o, dc.lod);
    case 'frame': return drawFrame(ctx, o, dc);
    case 'card': return drawCard(ctx, o, dc.lod, dc.scale);
    case 'text': return; // text only; drawn by the text cache
    case 'connector': return;
  }
}
